const getStockAlertLink = (allQueryStrings) => {
  const link = new URL("/search/StockAlerts", window.location.origin);

  if (Boolean(allQueryStrings["q"]))
    link.searchParams.append("q", allQueryStrings["q"]?.toString());
  if (Boolean(allQueryStrings["bq"]))
    link.searchParams.set("bq", allQueryStrings["bq"]?.toString());
  if (
    Boolean(allQueryStrings["MissingMileage"]) ||
    Boolean(allQueryStrings["MissingMileage"])
  )
    link.searchParams.set(
      "MissingMileage",
      allQueryStrings["MissingMileage"]?.toString() ||
        allQueryStrings["MissingMileage"]?.toString()
    );
  if (
    Boolean(allQueryStrings["AwaitingAppraisal"]) ||
    Boolean(allQueryStrings["Awaitingappraisal"])
  )
    link.searchParams.set(
      "AwaitingAppraisal",
      allQueryStrings["AwaitingAppraisal"]?.toString() ||
        allQueryStrings["Awaitingappraisal"]?.toString()
    );
  return link;
};

export default getStockAlertLink;
